export const environment = {
    production: true,
    base_url: 'https://api-dev.conexaris.com:52007',
    base_url_files: 'https://api-dev.conexaris.com:52007',
    base_url_ecommerce: 'https://api-dev.conexaris.com:52003',
    app_id: 'bWPipaxEXWATWXMNiN7gAzPw93z2wqug',
    bcrypt_salt: '$2a$10$2eUfZ70Uvt6GJv6am2zRjO',
    storage_encrypt_flag: true,
    ws_url_process: 'wss://api-dev.conexaris.com:52007',
    messages: {
        token_expired: {
            code: 'TOKEN_EXPIRED',
            description: 'Tu sesión ha expirado. Por favor iniciar sesión nuevamente.'
        },
        server_unavailable: {
            code: 'SERVER_UNAVAILABLE',
            description: 'El servicio se encuentra fuera de línea, será restablecido muy pronto.'
        },
        server_error: {
            code: 'SERVER_ERROR',
            description: 'Ha habido un incoveniente en el servicio. Intentelo nuevamente por favor.'
        },
        server_timeout: {
            code: 'SERVER_TIMEOUT',
            description: 'El servidor no ha respondido en el tiempo esperado. Intentelo nuevamente por favor.'
        },
        empty_result: {
            code: 'EMPTY_RESULT',
            description: 'No existen resultados.'
        },
        invalid_parameters: {
            code: "INVALID_PARAMETERS",
            description: 'Los parametros no son válidos.'
        }
    },
    companies: [
        {
            name: "conexaris",
            logo: "http://r1live.conexaris.com/LogosVirtualAssistant/Conexaris/ConexarisLogin.png",
            logo_app: "http://r1live.conexaris.com/LogosVirtualAssistant/Conexaris/ConexarisApp.png",
            account_string: 'AoExrvSaoBw9ywuUCN5w2HgtRT3q5K9u'
        },
        {
            name: "cruzdelsur",
            logo: "http://r1live.conexaris.com/LogosVirtualAssistant/CruzDelSur/CruzDelSurLogin.png",
            logo_app: "http://r1live.conexaris.com/LogosVirtualAssistant/CruzDelSur/CruzDelSurApp.png",
            account_string: 'ZGOMPWgbv0L5kPYGLLOv3MTcNJIEjtci'
        },
        {
            name: "cajasullana",
            logo: "http://r1live.conexaris.com/LogosVirtualAssistant/Conexaris/ConexarisLogin.png",
            logo_app: "http://r1live.conexaris.com/LogosVirtualAssistant/Conexaris/ConexarisApp.png",
            account_string: 'MlYtvpAaLRJyeh41H5Roc3zGZtHmhwF1'
        },
        {
            name: "mauchis",
            logo: "http://r1live.conexaris.com/LogosVirtualAssistant/Mauchis/MauchisLogin.png",
            logo_app: "http://r1live.conexaris.com/LogosVirtualAssistant/Mauchis/MauchisApp.png",
            account_string: 'Mt0gWYsQC93x7SwN3MeUCMGmK1xth5sJ'
        },
        {
            name: "apem",
            logo: "http://r1live.conexaris.com/LogosVirtualAssistant/Conexaris/ConexarisLogin.png",
            logo_app: "http://r1live.conexaris.com/LogosVirtualAssistant/Conexaris/ConexarisApp.png",
            account_string: 'HRnC1693UC5MZthh5IMFF5H4axuVCO6g'
        }
    ]
};
